import { render, staticRenderFns } from "./Costo.vue?vue&type=template&id=2efd608e&scoped=true&"
import script from "./Costo.vue?vue&type=script&lang=js&"
export * from "./Costo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2efd608e",
  null
  
)

export default component.exports